import dynamic from 'next/dynamic'
import { LocationVisitsIcon } from 'src/components/insights/icons/location-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/length-of-stay.png'

const LengthOfStay = dynamic(() => import('src/components/insights/location-visits/length-of-stay'), {
  ssr: false,
})

export const LengthOfStayWidget: InsightBuilderWidget = {
  id: 'length-of-stay',
  name: 'Length Of Stay',
  type: 'Location Visits',
  icon: LocationVisitsIcon,
  component: LengthOfStay,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
